import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-dark-900 text-white overflow-x-hidden" data-id="element-191">
      <HeroSection data-id="element-192" />
      <ProblemSection data-id="element-193" />
      <WhyFailedSection data-id="element-194" />
      <UniqueMechanism data-id="element-195" />
      <WhatYouGet data-id="element-196" />
      <WhoIsItFor data-id="element-197" />
      <CTASection data-id="element-198" />
      <Footer data-id="element-199" />
    </main>;
}